import http from '@/utils/http';
import { isDev } from '@utils/flag';
const $ = window.Zepto;

const url = window.location.origin
const BASE_URL = isDev()
  ? `${window.location.origin}/api`
  : window.location.origin;

module.exports = {


  // 扫码记录

  scanCp(data) {
    // return http
    //   // /workscene/v1/renovation/toC/cp/scanCp
    //   .get(`/workscene/workscene/v1/renovation/toC/cp/scanCp?personId=${data.personId}&userId=${data.userId}`)
    //   .then(res => {
    //     if (res.status === 200) {
    //       return res.data;
    //     } else {
    //       throw res;
    //     }
    //   });
    return new Promise((rs, rj) => {
      $.ajax({
        type: 'GET',
        url: `${BASE_URL}/workscene/v1/renovation/toC/cp/scanCp?personId=${data.personId}&userId=${data.userId}`,
        success(res) {
          rs(res.data);
        },
        error(err) {

          rj(err);
        },
      });
    });
  },

  // 目录列表
  apiGetList(userId) {
    return http
      .get(`/workscene/workscene/v1/renovation/toC/queryRenovationByUserId?userId=${userId}`)
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  // 详情
  apiGetDetail(data) {
    // return http
    //         .post(`/workscene/workscene/v1/renovation/toC/queryRenovation?id=${data.id}&idNo=${data.idNo}`)
    //         .then(res => {
    //           if (res.status === 200) {
    //             return res.data;
    //           } else {
    //             throw res;
    //           }
    //         });
    return new Promise((rs, rj) => {
      $.ajax({
        type: 'POST',
        url: `${BASE_URL}/workscene/v1/renovation/toC/queryRenovation?id=${data.id}&idNo=${data.idNo}`,
        success(res) {
          rs(res.data);
        },
        error(err) {

          rj(err);
        },
      });
    });
  },
  //   export const sg_app_login = (data) => {
  //     return doPost(`/api/phoenix/phoenix/arctic/v1/user/zs/app/login`, data)
  // }
  sg_app_login(param) {

    // const config = {
    //   dataType: 'json',
    //   contentType: 'application/json',
    // };
    // return http
    //   .post(
    //     '/phoenix/phoenix/arctic/v1/user/zs/app/login',
    //     param,
    //     {},
    //     config
    //   )
    //   .then(res => {
    //     if (res.status === 200) {
    //       return res.data;
    //     }
    //   });

    let api_url = isDev()
      ? `${window.location.origin}/sg_app`
      : window.location.origin;


    return new Promise((rs, rj) => {
      $.ajax({
        type: 'POST',
        // http://usermanage.intra.sit.sgwsf.gw/phoenix/arctic/v1/user/zs/app/login
        url: `${api_url}/api/phoenix/phoenix/arctic/v1/user/zs/app/login`,
        data: JSON.stringify(param),
        // "accept: application/json" -H "tenantId: " -H "Content-Type: application/json"
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json',
        },
        success(res) {
          rs(res.data);
        },
        error(err) {

          rj(err);
        },
      });
    });

  },

};
